import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6Zm0 6a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm.75 5.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextAlignLeftIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textAlignLeft')) as IconWithRender;

TextAlignLeftIcon.displayName = 'TextAlignLeftIcon';
TextAlignLeftIcon.propTypes = Icon.propTypes;
TextAlignLeftIcon.renderIcon = (props) => <TextAlignLeftIcon {...props} />;
export default TextAlignLeftIcon;
